<template>
  <div class="video-page">
    <video :src="src" width="100%" controls loop></video>
  </div>
</template>
<script>
export default {
  name: 'video',
  data () {
    return {
      src: ''
    }
  }
}
</script>
<style lang="less">
.video-page {
  width: 100%;
  height: 100%;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  video {
    width: 100%;
  }
}
</style>